/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Space,
  Popconfirm,
  message,
  Modal,
  Tag,
  Row,
  Col,
  DatePicker,
  Checkbox,
  Upload,
  Spin,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  FilterOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import {
  notificationConfigureApi,
  notificationTopicApi,
} from "../../api/NotificationApi";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  serialNum,
  spaceBeforeCapital,
  capitaliseWithHyphen,
} from "../../utils";
import NotificationDetailView from "../Notification/NotificationDetailView";
import urls from "../../api/urls";
import API from "../../api";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";
const { GET_USERS_MASTER_LIST, LEAD_CP_UPLOAD } = urls;

const NotificationCofigureList = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [form] = Form.useForm();
  const { Dragger } = Upload;
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState(0);
  const [users, setUsers] = useState([]);
  const [isModalOpenUsers, setIsModalOpenUsers] = useState(false);
  const [modalUsers, setModalUsers] = useState([]);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);
  const [notificationTopic, setNotificationTopic] = useState([]);
  const [eventType, setEventType] = useState([]);
  const [messageData, setMessageData] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filter, setFilter] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [selectedUserValues, setSelectedUserValues] = useState([]);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [filterByRole, setFilterByRole] = useState(false);
  const [notificationDetail, setNotificationDetail] = useState({
    data: {},
    open: false,
  });
  const pageUserSize = 10000;

  const prrioityList = [
    { value: "HIGH", label: "High" },
    { value: "MEDIUM", label: "Medium" },
    { value: "LOW", label: "Low" },
  ];

  const roleMap = {
    ROLE_HOADMIN: "HO Admin",
    ROLE_CPADMIN: "CP Admin",
    ROLE_CPOPERATOR: "CP Operator",
    ROLE_CPDRIVER: "CP Driver",
    ROLE_HOOPERATOR: "HO Operator",
    ROLE_HOMARKETING: "HO Marketing",
    ROLE_CPBOOKINGONLY: "CP Booking Only",
    ROLE_CLIENTADMIN: "Client Admin",
  };

  const userData = JSON.parse(localStorage.getItem("userinfo"));
  const userId = JSON.parse(localStorage.getItem("userId"));
  function getFormattedRole(roleKey) {
    return roleMap[roleKey] || roleKey;
  }

  const actionTypeList = [
    { value: "BUTTON", label: "Button" },
    { value: "LINK", label: "Link" },
    // { value: "TEXT", label: "Text" },
  ];
  const toolbarConfig = {
    fontColor: {
      colors: [
        {
          color: "hsl(0, 0%, 0%)",
          label: "Black",
        },
        {
          color: "hsl(0, 0%, 30%)",
          label: "Dim grey",
        },
        {
          color: "hsl(0, 0%, 60%)",
          label: "Grey",
        },
        {
          color: "hsl(0, 0%, 90%)",
          label: "Light grey",
        },
      ],
    },
    fontBackgroundColor: {
      colors: [
        {
          color: "hsl(0, 75%, 60%)",
          label: "Red",
        },
        {
          color: "hsl(30, 75%, 60%)",
          label: "Orange",
        },
        {
          color: "hsl(60, 75%, 60%)",
          label: "Yellow",
        },
        {
          color: "hsl(90, 75%, 60%)",
          label: "Light green",
        },
        {
          color: "hsl(120, 75%, 60%)",
          label: "Green",
        },

        // ...
      ],
    },
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "|",
        "fontColor",
        "|",
        "italic",
        "|",
        "link",
        "|",
        "underline",
        "|",
        "strikethrough",
        "|",
        "superscript",
        "subscript",
        "|",
        "bulletedList",
        "numberedList",
        "|",
        "insertTable",
        "|",
        "fontBackgroundColor",
        "|",
        "undo",
        "redo",
      ],
    },

    table: {
      contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
    },
    language: "en",
  };

  useEffect(() => {
    let filterVal = "";
    if (filter?.length > 0) {
      filterVal = `&filter=${filter}`;
    }
    const timeout = setTimeout(() => {
      getUsers(`?pageNum=0&pageSize=10000&search=${searchText}${filterVal}`);
    }, 300);

    return () => clearTimeout(timeout);
  }, [searchText]);

  useEffect(() => {
    getNotificationList({
      pageNo: pageNum,
      pageSize,
    });

    getUsers(`?pageNum=${0}&pageSize=${pageUserSize}`);
    getNotificationEventType();
  }, []);

  const getNotificationList = async (params) => {
    setLoading(true);
    const response = await notificationConfigureApi.getNotificationConfigure({
      ...params,
    });

    if (response?.status) {
      setTableData(response?.response?.data?.content || []);
      setTotalPageSize(response?.response?.data?.page?.totalElements || 0);
      setLoading(false);
    } else {
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
      setLoading(false);
    }
  };
  const getNotificationTopic = async () => {
    const response = await notificationTopicApi.getNotificationTopic();
    setNotificationTopic(
      response?.response?.data?.data?.map((e) => ({
        value: e?.name,
        label: spaceBeforeCapital(e?.name),
      })) || []
    );
  };

  const getNotificationEventType = async () => {
    const response = await notificationConfigureApi.getNotificationEventType();
    if (response?.status) {
      setEventType(
        response?.response?.data?.data?.map((e) => ({
          value: e?.eventType,
          label: spaceBeforeCapital(e?.eventType),
        })) || []
      );
    }
  };
  const getUsers = async (page) => {
    setDrawerLoading(true);
    const response = await API.Api(
      GET_USERS_MASTER_LIST + page
    ).getWithUserNPremiseHeader();
    if (response?.status) {
      setDrawerLoading(false);
      setUsers(
        response?.response?.data?.userListResponse?.map((item) => ({
          value: item?.userId?.toString(),
          searchText: `${item?.firstName} ${item?.lastName || ""} ${
            item?.mobileNum || ""
          } ${item?.premiseName || ""}`,
          label: (
            <span style={{ fontSize: "11px" }}>
              <span style={{ fontWeight: 500, fontSize: "13px" }}>
                {item?.firstName} {item?.lastName || ""}
              </span>{" "}
              {/* {item?.mobileNum && `(${item?.mobileNum})`}{" "} */}
              {item?.roleAs && (
                <Tag color="blue" style={{ fontSize: "9px", padding: "0px" }}>
                  {getFormattedRole(item?.roleAs)}
                </Tag>
              )}
              {item?.assignUser?.toUpperCase() === "CP" &&
                item?.premiseName &&
                `(${item?.premiseName})`}
            </span>
          ),
        }))
      );
    } else {
      setDrawerLoading(false);
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
    }
  };
  const handleDelete = (id) => {
    setTableData(tableData.filter((item) => item.id !== id));
  };

  const showModalUsers = async (id) => {
    const response =
      await notificationConfigureApi.getNotificationConfigureDetails(id);
    if (response?.status) {
      setModalUsers(response?.response?.data?.recipientsNames);
      setIsModalOpenUsers(true);
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const handleModalCloseUsers = () => {
    setIsModalOpenUsers(false);
    setModalUsers([]);
    setSelectedNotificationId(null);
  };

  const openDetails = (item) => {
    setNotificationDetail({ data: item, open: true });
  };

  const columns = [
    {
      title: "SI",
      dataIndex: "sl",
      width: "5%",
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "Event Type",
      dataIndex: "eventType",
      key: "eventType",
      width: "10%",
      render: (data) => capitaliseWithHyphen(data) || "-",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      width: "8%",
    },
    {
      title: "Recipients",
      dataIndex: "recipientsCount",
      key: "recipientsCount",
      width: "5%",
      render: (data, record) => {
        return (
          <>
            {/* <Tag color="blue">{firstUser}</Tag> */}
            {data > 0 && (
              <Button
                type="link"
                onClick={() => showModalUsers(record?.id)}
                style={{
                  padding: "0",
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  background: "#16A34A",
                  color: "#fff",
                  fontSize: "12px",
                }}
              >
                {data}
              </Button>
            )}
          </>
        );
      },
    },
    {
      title: "Topic",
      dataIndex: "topics",
      key: "topics",
      render: (text, record) => capitaliseWithHyphen(text?.[0] || "N/A"),
      width: "5%",
    },
    {
      title: "Notification Title",
      dataIndex: "notificationTitle",
      key: "notificationTitle",
      render: (text, record) =>
        formatText(record?.channels?.default?.title, 100),

      ///render: (data, record) => record?.channels?.default?.title || "-",
      width: "30%",
      //align: "center",
    },

    // {
    //   title: "Expiry Date",
    //   dataIndex: "expiaryDate",
    //   key: "expiaryDate",
    //   render: (data) => data?.split("T")[0] || "-",
    //   width: "10%",
    //   align: "center",
    // },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (data) => data?.split("T")[0] || "-",
      width: "10%",
      align: "center",
    },
    // {
    //   title: "Action Type",
    //   dataIndex: "actionType",
    //   key: "actionType",
    //   render: (data) => data?.[0]?.actionType || "-",
    //   width: "10%",
    //   align: "center",
    // },
    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => (
        <Space>
          <Button
            type="text"
            icon={<EyeOutlined style={{ color: "#2e69fc" }} />}
            //disabled
            onClick={() => openDetails(record)}
          />
          {/* <Popconfirm
            title="Are you sure you want to delete this notification?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          > */}
          {/* <Button
            type="text"
            danger
            disabled
            icon={<DeleteOutlined style={{ color: "#2e69fc" }} />}
          /> */}
          {/* </Popconfirm> */}
        </Space>
      ),
    },
  ];

  const handleCreateNotification = () => {
    form.setFieldsValue({
      priority: "HIGH",
    });
    getNotificationTopic();
    setIsDrawerOpen(true);
  };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  const handleEdit = async (record) => {
    const response =
      await notificationConfigureApi.getNotificationConfigureDetails(record.id);
    if (response?.status) {
      setSelectedNotificationId(record.id);
      let data = response?.response?.data;
      form.setFieldsValue({
        eventType: data?.eventType,
        priority: data?.priority,
        expiaryDate: moment(data?.expiaryDate, "DD-MM-YYYY"),
        recipients: data?.recipients,
        topic: data?.topics?.[0],
        actionType: data?.actions?.[0]?.actionType,
        actionUrl: data?.actions?.[0]?.url,
        notificationTitle: data?.notificationTitle,
        message: data?.message,
      });
      setIsDrawerOpen(true);
    } else {
      message.error(response?.response?.data?.message);
    }
  };

  const onClose = () => {
    form.resetFields();
    setIsDrawerOpen(false);
    setSelectedNotificationId(null);
    setFilter([]);
    setFileList([]);
    setSelectedUserValues([]);
  };

  const onSubmit = async (values) => {
    setLoading(true);
    if (!values?.topic && !values?.recipients) {
      message.error("Please select topic or recipients");
      return;
    }
    let payload = {
      eventType: values?.eventType,
      priority: values?.priority,
      expiaryDate: values?.expiaryDate,
      recipients: values?.recipients,
      topics: values?.topic ? [values?.topic] : [],
      category: "generic",
      channels: {
        default: {
          title: values?.notificationTitle,
          message: messageData,
          file: fileList?.map((val) => ({
            url: val?.response,
            type: val?.name?.split(".")[val?.name?.split(".")?.length - 1],
          })),
        },
      },
      actions:
        values?.actionType || values?.actionUrl || values?.actionUrl
          ? [
              {
                actionType: values?.actionType,
                title: values?.title,
                url: values?.actionUrl,
              },
            ]
          : undefined,
    };

    let response;
    if (selectedNotificationId) {
      response = await notificationConfigureApi.putNotificationConfigure(
        selectedNotificationId,
        payload
      );
    } else {
      response = await notificationConfigureApi.postNotificationConfigure(
        payload
      );
    }
    if (response?.status) {
      setLoading(false);
      message.success(response?.response?.data?.message);
      onClose();
      getNotificationList({
        pageNo: 1,
        pageSize,
      });
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const handleTableChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
    getNotificationList({
      pageNo: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  ///Attachment Upload///

  const fileProps = {
    name: "files",
    multiple: true,
    listType: "picture",
    showUploadList: true,
    action: `${LEAD_CP_UPLOAD + "document"}`,
    className: "upload-list-inline",

    fileList:
      Array.isArray(fileList) &&
      fileList.length > 0 &&
      typeof fileList[0] === "object"
        ? fileList
        : fileList?.length
        ? fileList?.map((val) => {
            return { name: val?.split("/").pop(), response: val };
          })
        : null,
  };

  const beforeUpload = (file, onSuccess) => {
    // const isJpgOrPng =
    //   file.type === "image/jpeg" ||
    //   file.type === "image/png" ||
    //   file.type === "application/pdf";
    // const isLt2M = file.size / 1024 / 1024 < 5;
    if (file) {
      let checkSameFile = fileList
        ?.map((val) => val?.name)
        .some((val) => val === file?.name);

      // if (file?.name?.includes("jfif")) {
      //   message.error("File not supported");
      //   return Upload.LIST_IGNORE;
      // }
      if (checkSameFile) {
        message.error("Same file cannot be uploaded again");
        return Upload.LIST_IGNORE;
      }
      // if (!isLt2M) {
      //   message.error("File size should be less than 10MB");
      //   return Upload.LIST_IGNORE;
      // }
      // if (!isJpgOrPng) {
      //   message.error("File not supported");
      //   return Upload.LIST_IGNORE;
      // }
      // return isJpgOrPng && isLt2M;
    } else {
      if (onSuccess) {
        message.success("File uploaded");
      }
      onSuccess("ok");
      return true;
    }
  };
  const handleChange = (info) => {
    let allFiles = info?.fileList?.map((val) => val?.response?.data);
    if (info?.file?.status === "done") {
      form.setFieldValue("idUrl", allFiles);
      message.success(
        info?.file?.response?.message || "Document uploaded successully"
      );
      form.setFields([
        {
          name: "idUrl",
          errors: null,
          message: null,
        },
      ]);
    }
    if (info?.file?.status === "error") {
      message.error("File not Supported");
    }
    setFileList(info?.fileList);
  };

  const handlePreview = async (file) => {
    window.open(file?.response);
  };
  const headers = {
    Authorization: "Bearer " + userData?.accessToken,
    "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
    "USER-ID": userId?.userInfo?.userId,
  };

  const handleUserChange = (values) => {
    if (values.includes("select_all")) {
      const allValues = users.map((user) => user.value);
      setSelectedUserValues(allValues);
      form.setFieldsValue({
        recipients: allValues,
      });
    } else if (values.includes("diselect_all")) {
      setSelectedUserValues([]);
      form.setFieldsValue({
        recipients: [],
      });
    } else {
      //setSelectedUserValues(values);
      form.setFieldsValue({
        recipients: values,
      });
    }
  };

  const customOptions = [];

  if (users?.length > 0) {
    customOptions.push({
      label: <b>Select All</b>,
      value: "select_all",
    });

    if (selectedUserValues?.length > 0) {
      customOptions.push({
        label: <b>Deselect All</b>,
        value: "diselect_all",
      });
    }

    customOptions.push(...users);
  }

  return (
    <div>
      <NotificationDetailView
        item={notificationDetail?.data || {}}
        open={notificationDetail?.open || false}
        setOpen={() => {
          setNotificationDetail({ data: {}, open: false });
        }}
        notificationCreateView={true}
      />
      <div className="flex-end">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleCreateNotification}
          style={{ marginTop: "-10px" }}
          className="save-btn"
        >
          Create Notification
        </Button>
      </div>
      <Table
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        className="mt-1 wallet-table"
        columns={columns}
        //defaultCurrent={1}
        onChange={handleTableChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: totalPageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
      <Drawer
        title={
          selectedNotificationId ? "Edit Notification" : "Create Notification"
        }
        placement="right"
        onClose={onClose}
        open={isDrawerOpen}
        width={720}
      >
        <Spin spinning={drawerLoading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
            className="global-form"
          >
            <Row className="global-form-row" gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="eventType"
                  label="Event Type"
                  rules={[
                    { required: true, message: "Please enter event type" },
                  ]}
                >
                  <Select placeholder="Select event type" options={eventType} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="priority"
                  label="Priority"
                  rules={[{ required: true, message: "Please enter priority" }]}
                >
                  <Select
                    placeholder="Select priority"
                    options={prrioityList}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="topic"
                  label="Select Topic"
                  //rules={[{ required: true, message: "Please select topic" }]}
                >
                  <Select
                    placeholder="Select topic"
                    options={notificationTopic}
                    // options={notificationTopic.map((item) => ({
                    //   label: item?.label,
                    //   value: item?.value,
                    //   disabled: item?.label?.toLowerCase() != "all cps",
                    // }))}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Checkbox
                  checked={filterByRole}
                  onChange={(e) => setFilterByRole(e.target.checked)}
                >
                  <p className="mt-1">
                    <FilterOutlined /> Filter recipients by Role
                  </p>
                </Checkbox>
              </Col>
              <Col span={24}>
                {filterByRole && (
                  <Checkbox.Group
                    className="mb-1"
                    value={filter}
                    onChange={(value) => {
                      setFilter(value);
                      let filterVal;
                      if (value.length > 0) {
                        filterVal = `&filter=${value}`;
                      }
                      getUsers(
                        `?pageNum=${0}&pageSize=${pageUserSize}${
                          filterVal || ""
                        }`
                      );
                    }}
                  >
                    <Row>
                      {Object.keys(roleMap).map((role) => (
                        <Col span={6} key={role}>
                          <Checkbox value={role}>{roleMap[role]}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </Checkbox.Group>
                )}
              </Col>
              <Col span={24}>
                <Form.Item
                  name="recipients"
                  label={`Recipients (${selectedUserValues?.length})`}
                  // rules={[
                  //   { required: true, message: "Please select recipients" },
                  // ]}
                >
                  <Select
                    onChange={handleUserChange}
                    mode="multiple"
                    placeholder="Select recipients"
                    //options={users}
                    style={{ width: "100%" }}
                    showSearch
                    onSearch={(value) => setSearchText(value)}
                    options={customOptions}
                    onClear={() => {
                      form.setFieldsValue({
                        recipients: [],
                      });
                    }}
                    // onSearch={(value) => {
                    //   getUsers(
                    //     `?pageNum=${0}&pageSize=${pageUserSize}&search=${value}`
                    //   );
                    // }}
                    filterOption={(input, option) =>
                      option?.searchText
                        ?.toLowerCase()
                        ?.includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="notificationTitle"
                  label="Notification Title"
                  rules={[
                    {
                      required: true,
                      message: "Please enter notification title",
                    },
                  ]}
                >
                  <Input placeholder="Enter notification title" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="message" label="Message">
                  <CKEditor
                    config={toolbarConfig}
                    editor={ClassicEditor}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      if (data.length > 1000) {
                        message.error(
                          "message cannot be more than 1000 characters"
                        );
                        event.preventDefault();
                      } else {
                        setMessageData(data);
                      }
                    }}
                    maxLength={10}
                  />
                  {messageData.length + "/1000"}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="attachment"
                  label="Attachments"
                  //rules={[{ required: true, message: "Please upload a file" }]}
                >
                  <Dragger
                    {...fileProps}
                    className="dragger-doc"
                    onChange={handleChange}
                    //onRemove={handleRemoveFile}

                    onPreview={handlePreview}
                    beforeUpload={beforeUpload}
                    multiple={true}
                    headers={headers}
                    fileList={fileList}
                  >
                    <Row>
                      <Col span={24}>
                        <UploadOutlined /> <span>Upload Files</span>
                      </Col>
                    </Row>
                  </Dragger>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="title"
                  label="Action Title"
                  // rules={[
                  //   { required: true, message: "Please select action type" },
                  // ]}
                >
                  <Input placeholder="Enter action title" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="actionType"
                  label="Action Type"
                  // rules={[
                  //   { required: true, message: "Please select action type" },
                  // ]}
                >
                  <Select
                    placeholder="Select action type"
                    options={actionTypeList}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="actionUrl"
                  label="Action URL"
                  //rules={[{ required: true, message: "Please select action" }]}
                >
                  <Input placeholder="Enter action url" />
                </Form.Item>
              </Col>
              {/* <Col span={12}>
              <Form.Item
                name="scheduleDate"
                label="Schedule Date"
                rules={[
                  { required: true, message: "Please select schedule date" },
                ]}
              >
                <DatePicker />
              </Form.Item>
            </Col> */}
              {/* <Col span={12}>
              <Form.Item
                name="expiaryDate"
                label="Expiry Date"
                rules={[
                  { required: true, message: "Please select expiry date" },
                ]}
              >
                <DatePicker format="DD-MM-YYYY" />
              </Form.Item>
            </Col> */}
            </Row>
            <div className="flex-end mt-2">
              <Button onClick={onClose} className="mr-1">
                Cancel
              </Button>
              <Button type="primary" htmlType="submit" className="save-btn">
                Submit
              </Button>
            </div>
          </Form>
        </Spin>
      </Drawer>
      <Modal
        title="Subscribed Users"
        open={isModalOpenUsers}
        onCancel={handleModalCloseUsers}
        footer={null}
      >
        <Space wrap>
          {modalUsers.map((user, index) => (
            <Tag key={index} color="geekblue">
              {user}
            </Tag>
          ))}
        </Space>
      </Modal>
    </div>
  );
};

export default NotificationCofigureList;
